"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var paletteQuantizer_1 = require("./paletteQuantizer");
exports.AbstractPaletteQuantizer = paletteQuantizer_1.AbstractPaletteQuantizer;
var neuquant_1 = require("./neuquant/neuquant");
exports.NeuQuant = neuquant_1.NeuQuant;
var neuquantFloat_1 = require("./neuquant/neuquantFloat");
exports.NeuQuantFloat = neuquantFloat_1.NeuQuantFloat;
var rgbquant_1 = require("./rgbquant/rgbquant");
exports.RGBQuant = rgbquant_1.RGBQuant;
var colorHistogram_1 = require("./rgbquant/colorHistogram");
exports.ColorHistogram = colorHistogram_1.ColorHistogram;
var wuQuant_1 = require("./wu/wuQuant");
exports.WuQuant = wuQuant_1.WuQuant;
exports.WuColorCube = wuQuant_1.WuColorCube;
//# sourceMappingURL=index.js.map